/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Servicenowclientid3Inputs */

const en__field_servicenowclientid3 = /** @type {(inputs: _Field_Servicenowclientid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow customer`)
};

/**
* | output |
* | --- |
* | "ServiceNow customer" |
*
* @param {_Field_Servicenowclientid3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_servicenowclientid3 = /** @type {((inputs?: _Field_Servicenowclientid3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Servicenowclientid3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_servicenowclientid3(inputs)
});
export { _field_servicenowclientid3 as "_field_serviceNowClientId" }